var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.53125L13.125 2.60938C13.875 1.29688 15.2344 0.5 16.7344 0.5H16.875C19.125 0.5 21 2.375 21 4.625C21 5.32812 20.8125 5.9375 20.5312 6.5H21.75C22.9688 6.5 24 7.53125 24 8.75V11.75C24 12.7344 23.3438 13.5781 22.5 13.9062V21.5C22.5 23.1875 21.1406 24.5 19.5 24.5H4.5C2.8125 24.5 1.5 23.1875 1.5 21.5V13.9062C0.609375 13.5781 0 12.7344 0 11.75V8.75C0 7.53125 0.984375 6.5 2.25 6.5H3.42188C3.14062 5.9375 3 5.32812 3 4.625C3 2.375 4.82812 0.5 7.125 0.5H7.21875C8.71875 0.5 10.0781 1.29688 10.8281 2.60938L12 4.53125ZM13.5 8.75V11.75H21.75V8.75H13.5ZM10.5 8.75H2.25V11.75H10.5V8.75ZM10.5 14H3.75V21.5C3.75 21.9219 4.07812 22.25 4.5 22.25H10.5V14ZM13.5 22.25H19.5C19.875 22.25 20.25 21.9219 20.25 21.5V14H13.5V22.25ZM16.875 6.5C17.9062 6.5 18.75 5.70312 18.75 4.625C18.75 3.59375 17.9062 2.75 16.875 2.75H16.7344C16.0312 2.75 15.4219 3.125 15.0469 3.73438L13.4062 6.5H16.875ZM10.5469 6.5L8.90625 3.73438C8.53125 3.125 7.92188 2.75 7.21875 2.75H7.125C6.04688 2.75 5.25 3.59375 5.25 4.625C5.25 5.70312 6.04688 6.5 7.125 6.5H10.5469Z",
    fill: "#BE0042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e104af3fd4338c18979c89a5dd92631a.svg";
export { ForwardRef as ReactComponent };